exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form[data-v-5903a642]{max-width:650px;margin:0 auto 36px;padding:36px 27px;background-color:#f3f3f3;border-radius:4px}@media screen and (min-width:641px){.form[data-v-5903a642]{margin:0 auto 57px;padding:36px 54px}}.form__label[data-v-5903a642]{margin-bottom:9px;padding-bottom:9px;font-family:inherit;line-height:1.3;font-size:13px;color:#464646;text-transform:uppercase;border-bottom:1px solid #dadada}.form__fields[data-v-5903a642]{margin-bottom:27px;display:-ms-grid;display:grid;row-gap:18px}.form__fields .edu-level[data-v-5903a642]{grid-column:1/3}@media screen and (min-width:641px){.form__fields[data-v-5903a642]{-ms-grid-columns:(minmax(150px,1fr))[2];grid-template-columns:repeat(2,minmax(150px,1fr));column-gap:27px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5903a642","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/catalog/card/components/request/components/requestform/RequestForm.vue
// module id = 4f53293fc43e3962961d
// module chunks = 6